import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { PasswordModule } from 'primeng/password';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { DividerModule } from 'primeng/divider';
import { ToolbarModule } from 'primeng/toolbar';
import { SidebarModule } from 'primeng/sidebar';
import { SlideMenuModule } from 'primeng/slidemenu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ChartModule } from 'primeng/chart';
import { CarouselModule } from 'primeng/carousel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuModule } from 'primeng/menu';
import { TableModule } from 'primeng/table';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DialogModule } from 'primeng/dialog';

import { LoginComponent } from './features/login/login.component';
import { EsqueciSenhaComponent } from './features/esqueci-senha/esqueci-senha.component';
import { AtualizarSenhaComponent } from './features/atualizar-senha/atualizar-senha.component';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './features/home/home.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ListaPedidosComponent } from './features/lista-pedidos/lista-pedidos.component';
import { LogoComponent } from './shared/components/logo/logo.component';
import { HttpAuthInterceptor } from './core/interceptors/http-auth.interceptor';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { AuthenticationInvalidDialogComponent } from './shared/components/authentication-invalid-dialog/authentication-invalid-dialog.component';
import { NovoPedidoComponent } from './features/novo-pedido/novo-pedido.component';
import { CpfCnpjPipe } from './shared/pipes/cpf-cnpj.pipe';
import { NovoPedidoOlhoComponent } from './features/novo-pedido/components/novo-pedido-olho/novo-pedido-olho.component';
import { NovoPedidoOutrosServicosComponent } from './features/novo-pedido/components/novo-pedido-outros-servicos/novo-pedido-outros-servicos.component';
import { NumberDirective } from './core/directives/restricted-decimals.directive';
import { PedidoLaboratorioComponent } from './features/novo-pedido/components/pedido-laboratorio/pedido-laboratorio.component';
import { PedidoAtacadoComponent } from './features/novo-pedido/components/pedido-atacado/pedido-atacado.component';
import { FiltrosPedidosComponent } from './features/lista-pedidos/components/filtros-pedidos/filtros-pedidos.component';
import { ToastrModule } from 'ngx-toastr';1
import { DeviceService } from './core/services/device.service';

import ptBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';

registerLocaleData(ptBr);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    EsqueciSenhaComponent,
    AtualizarSenhaComponent,
    HomeComponent,
    DashboardComponent,
    ListaPedidosComponent,
    LogoComponent,
    NotFoundComponent,
    AuthenticationInvalidDialogComponent,
    NovoPedidoComponent,
    CpfCnpjPipe,
    NovoPedidoOlhoComponent,
    NovoPedidoOutrosServicosComponent,
    NumberDirective,
    PedidoLaboratorioComponent,
    PedidoAtacadoComponent,
    FiltrosPedidosComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-full-width',
      timeOut: 5000,
    }), // ToastrModule added
    FormsModule,
    AppRoutingModule,
    InputTextModule,
    ButtonModule,
    CardModule,
    PasswordModule,
    MessagesModule,
    ToastModule,
    DividerModule,
    ToolbarModule,
    SidebarModule,
    SlideMenuModule,
    PanelMenuModule,
    ChartModule,
    CarouselModule,
    ProgressSpinnerModule,
    SplitButtonModule,
    MenuModule,
    TableModule,
    CalendarModule,
    DropdownModule,
    ConfirmDialogModule,
    FieldsetModule,
    RadioButtonModule,
    InputNumberModule,
    InputTextareaModule,
    AutoCompleteModule,
    InputMaskModule, 
    DialogModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    MessageService,
    ConfirmationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthInterceptor,
      multi: true
    },
    DeviceService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
